import axios from 'axios'
import { Message } from 'element-ui'
import { TIMEOUT_CONFIG, getTimeoutMs } from '@/config/timeout'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})

// 更新最后操作时间
function updateLastActivity() {
  localStorage.setItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY, Date.now().toString())
}

// 检查用户是否超时
function checkUserInactivity() {
  const lastActivity = localStorage.getItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY)
  if (!lastActivity) return false
  
  const now = Date.now()
  const timeDiff = now - parseInt(lastActivity)
  const timeoutMs = getTimeoutMs()
  
  return timeDiff > timeoutMs
}

// 自动登出
function autoLogout() {
  Message.warning('由于长时间未操作，系统已自动退出登录')
  localStorage.removeItem('access')
  localStorage.removeItem('refresh')
  localStorage.removeItem('permissions')
  localStorage.removeItem('username')
  localStorage.removeItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY)
  window.location.href = '/login'
}

// eslint-disable-next-line no-unused-vars
async function refreshToken() {
  try {
    const refresh = localStorage.getItem('refresh')
    if (!refresh) {
      throw new Error('No refresh token')
    }
    
    const response = await axios.post(process.env.VUE_APP_BASE_API + 'token/refresh/', {
      refresh: refresh
    })
    
    if (response.data && response.data.access) {
      localStorage.setItem('access', response.data.access)
      console.log('Token 已自动刷新')
      return response.data.access
    }
  } catch (error) {
    console.error('Token 刷新失败:', error)
    throw error
  }
}

// 初始化用户活动监听
function initActivityMonitor() {
  // 监听用户操作事件
  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click']
  
  events.forEach(event => {
    document.addEventListener(event, updateLastActivity, true)
  })
  
  // 定期检查用户是否超时
  setInterval(() => {
    if (checkUserInactivity() && localStorage.getItem('access')) {
      autoLogout()
    }
  }, TIMEOUT_CONFIG.CHECK_INTERVAL) // 每分钟检查一次
}

// 初始化活动监听器
if (typeof window !== 'undefined') {
  initActivityMonitor()
}

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // 更新最后操作时间
    updateLastActivity()
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    // 更新最后操作时间
    updateLastActivity()
    return response
  },
  async error => {
    const { response } = error
    if (response && response.status === 403) {
      // 清理本地存储
      localStorage.removeItem('access')
      localStorage.removeItem('refresh')
      localStorage.removeItem('permissions')
      localStorage.removeItem('username')
      localStorage.removeItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY)
      // 跳转登录页
      window.location.href = '/login'
      // 阻止后续catch和多余报错
      return Promise.reject()
    }
    return Promise.reject(error)
  }
)

export default service 